<template>
  <span :class="[$style['chip'], { [$style[`chip--${color}`]]: color }, , { [$style[`chip--${size}`]]: size }]">
    <slot />
  </span>
</template>
<script setup>
defineProps({
  color: {
    type: String,
    default: null
  },
  size: {
    type: String,
    default: null
  }
})
</script>
<style lang="scss" module>
.chip {
  background-color: $grey-light;
  color: $grey-dark;
  display: inline-flex;
  align-items: center;
  font-size: $font-size-xs;
  font-weight: $font-weight-bold;
  border-radius: 9999px;
  height: $spacing * 3;
  padding: 0 $spacing * 2;
  text-transform: uppercase;
  white-space: nowrap;

  &--green {
    background-color: $success-light;
    color: $success-dark;
  }

  &--yellow {
    background-color: $gold-light;
    color: $gold-dark;
  }

  &--red {
    background-color: $red-light;
    color: $red-dark;
  }

  &--black {
    background-color: $black;
    color: $white;
  }

  &--white {
    background-color: $white;
    box-shadow: inset 0 0 0 1px $grey-light;
    color: $grey;
  }

  &--small {
    padding: 0 $spacing;
    font-size: $font-size-xs - 0.1rem;
  }
}
</style>
